import {toggleClass,find} from '@services/dom'
import {pageIntroDuration} from '@services/config'
import {subscribe} from '@services/events'

const hasConsent = consent => {
    if(consent === undefined) return !!parseInt(localStorage.getItem('cookieConsent') || 0,10);
    localStorage.setItem('cookieConsent',!!consent?'1':'0')
}

const CookieConsent = ()=>{
    const [el] = find('.cookie-consent');
    toggleClass(el,'animate',true);
    if(document.documentElement.classList.contains('no-intro')) {
        toggleClass(el,'needs-consent',!hasConsent());
    }else{
        setTimeout(()=>{
            toggleClass(el,'needs-consent',!hasConsent());
        },pageIntroDuration);
    }

    find('[data-action="accept"]').map(accept => {
        accept.addEventListener('click',()=>{
            hasConsent(true);
            toggleClass(el,'needs-consent',false);
        });
    })
}

const listener = subscribe(document,'page:fullyInitialized',()=>{
    CookieConsent();
    listener();
});
